import React, { useState, useEffect } from "react"
import { useAppCtx, appStore } from "lib/state"
import { appTools, cn, randoms } from "lib/utils"
import useStatements from "lib/units/element/Statement/useStatements"
import useTemplate from "lib/units/template/useTemplate"


/* ====== The statement marker is used to represent a statement that is not currently selected. ====== */

export default function StatementMarker({ 
  template, 
  statementObj, 
  level=1,
  saveTemplateFn,
  updateTemplateWithStatement
} : { 
  template:any
  statementObj:any
  level?:number 
  saveTemplateFn:any
  updateTemplateWithStatement:any 
}){
  
  const { store, AppStore }:any = appStore()
  const { update, syncActiveToCollection, syncCollectionToActive, swapItemsInActiveState }:any = AppStore

  const { templateTools } = useTemplate(template)
  const { statementTools } = useStatements()

  const [ statementMode, setStatementMode ] = useState<string>("list")
  const [ nestedObject, setNestedObject ] = useState<string>()
  const [ dragDropState, setDragDropState ] = useState<string>("idle")
  const [ showChangeTitle, setShowChangeTitle ] = useState<boolean>(false)
  const [ newTitle, setNewTitle ] = useState<string>(statementObj.title)

  const getTitlePrefix = () => {
    if( statementObj.conditional !== null && statementObj.content !== null ){
      return "Conditional + Content:"
    } else if ( statementObj.conditional !== null ){
      return "Conditional:"
    } else if ( statementObj.content !== null ){
      return "Content:"
    } else {
      return ""
    }
  }

  const handleCloneStatement = (statement:any) => {
    update("ui.toast", { 
      id: Date.now(), 
      visible: true, 
      type: "confirm", 
      message: "Please confirm clone operation:", 
      onConfirm: () => {
        const clone = statementTools.clone(statement)
        templateTools.statement.add(
          clone, 
          (data:any) => saveTemplateFn.mutate({ resource: "template", data }, () => update("randomizers.statements", randoms.string(8,"a#")))
      )}
    })
  }

  
  const handleDeleteStatement = (refstr:string) => {
    update("ui.toast", { 
      id: Date.now(), 
      visible: true, 
      type: "confirm", 
      message: "Are you sure you want to delete this statement?", 
      onConfirm: () => templateTools.statement.remove(
      template, 
      refstr, 
      (data:any) => saveTemplateFn.mutate({ resource: "template", data })
    )})
  }


  const changeSelectedStatement = (statementObj:any) => update("actives.statement", statementObj) 

  const titlebarItemClasses = "flex justify-end items-center cursor-pointer"

  return (
    <div 
      draggable={true}
      onDragStart={(e) => {
        setDragDropState("dragging")
        e.dataTransfer.setData("text/plain", statementObj.refstr)
      }}
      onDrop={(e) => {
        e.preventDefault()
        // setDragDropState("idle")
        // const targetStatement = e.dataTransfer.getData("text/plain")
        // const droppedStatement = statementObj.refstr
        // StatementTools.reorderStatement(targetStatement, droppedStatement)
      }}
      onDragOver={(e) => {
        e.preventDefault()
        setDragDropState("dragover")
      }}
      onDragLeave={() => setDragDropState("idle")}
      onDragEnd={() => setDragDropState("idle")}
      className={cn(
        "w-full border border-solid border-slate-700 flex flex-col justify-center items-start text-sm opacity-50",
        dragDropState === "dragging" && "bg-green-700 opacity-30",
        dragDropState === "dragover" && "border-yellow-500"
      )}
    >
      <div className={cn("w-full h-8 flex justify-between items-center bg-slate-700 text-neutral-300/70 uppercase")}>
        <div className="w-8/12 h-full flex items-center px-3">
          { showChangeTitle === true ? (
            <div className="w-full h-full flex gap-1 justify-start items-center p-[2px]">
              <input type="text" className="w-36 h-full px-1 border border-solid border-slate-400 bg-transparent focus:border-slate-100 focus:outline-none placeholder:text-white placeholder:px-1" placeholder="Enter statement title" name="newTitle" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} />
              <button 
                type="button" 
                className="h-full px-2 bg-teal-600 text-white uppercase text-xs" 
                onClick={() => {
                  updateTemplateWithStatement({...statementObj, title: newTitle});
                  setShowChangeTitle(false)
                }}
              >
                save
              </button>
            </div>
          ):(
            <span onClick={() => setShowChangeTitle(true)}>{statementObj.title || "Untitled"}</span>
          )}


        </div>
          <div className="w-4/12 flex justify-end items-center gap-6 pr-3">
            { statementObj.refstr !== store.actives.statement?.refstr ? (
              <>
                <div onClick={() => changeSelectedStatement(statementObj)} className={cn(titlebarItemClasses)}>select</div>
                <div 
                  className={cn(titlebarItemClasses)}
                  onClick={() => handleCloneStatement(statementObj)} 
                >
                  clone
                </div>
                <div onClick={() => handleDeleteStatement(statementObj.refstr)} className={cn(titlebarItemClasses)}>delete</div>
              </>
            ):(
              <>
                <div 
                  onClick={() => update("actives.statement", statementObj)}
                  className={cn(titlebarItemClasses)}
                >
                  edit
                </div>
                <div 
                  onClick={() => handleDeleteStatement(statementObj.refstr)} 
                  className={cn(titlebarItemClasses)}
                >
                  delete
                </div>
              </>
            )}
          </div>
      </div>

      <div className="w-full px-3 py-2">
        { statementObj.content.pass.substring(0,150) }...
        {/* { statementObj.description || "No description provided" } */}
      </div>

      { store.actives.statement !== null && store.element.refstr === "opening_statements" && statementObj.conditional !== null && (statementObj.if_passes !== undefined || statementObj.if_fails !== undefined) && (
        <div className="w-[98%] mx-auto my-2 flex flex-col border border-solid border-slate-700 p-[4px]">
          <div className="w-full h-6 flex p-[2px]">

            { statementObj.if_passes !== undefined && (
              <div 
                onClick={() => setNestedObject("if_passes")}
                className={cn(
                  "w-6/12 flex justify-center items-center text-xs uppercase border border-solid border-slate-700 cursor-pointer",
                  nestedObject === "if_passes" && "bg-green-700/50"
                )}
              >
                pass
              </div>
            )}

            { statementObj.if_fails !== undefined && (
              <div 
                onClick={() => setNestedObject("if_fails")}
                className={cn(
                  "w-6/12 flex justify-center items-center text-xs uppercase border border-solid border-slate-700 cursor-pointer",
                  nestedObject === "if_fails" && "bg-red-700/50"
                )}
              >
                fail
              </div>
            )}
          </div>

          { nestedObject !== undefined && (
            <div className="w-full my-2">
              { statementObj.nested[nestedObject] === null || statementObj.nested[nestedObject] === undefined ? (
                <div className="w-full h-8 flex justify-center items-center bg-slate-700 text-neutral-300/70 uppercase">
                  [ no action specified ]
                </div>
              ):(
                <StatementMarker 
                  template={template} 
                  statementObj={statementObj.nested[nestedObject]} 
                  level={level+1} 
                  saveTemplateFn={saveTemplateFn}
                  updateTemplateWithStatement={updateTemplateWithStatement}
                />
              )}
            </div>
          )}

        </div>
      )}


    </div>
  )

}